<template>
    <form
        @submit.prevent="registerByEmail"
        @click="recaptcha"
        class="enter-cabinet__tab form-vertical registration-email"
    >
        <div v-if="authData.authInfo.showSMS">
            <span>{{authData.messages.phone_code_get_message}}</span>
        </div>
        <div v-for="input in authData.regInputs">
            <def-input
                v-if="input.name === 'USER_NAME'"
                :required="input.type !== 'hidden'"
                :name="input.name"
                :type="input.type"
                :value="input.value"
                :error="input.error"
                :label="input.placeholder"

            />
            <DefPhone
                v-else-if="input.name === 'USER_PHONE_NUMBER'"
                :required="input.type !== 'hidden'"
                :name="input.name"
                :value="input.value"
                :error="input.error"
                :label="input.placeholder"
            />
        </div>

        <!--     выбор регистрации через телефон или почту   -->
        <enter-cabinet-choose />
        <div class="enter-cabinet__tab form-vertical">

            <!--            <div v-if="authData.authInfo.showSMS">-->
            <!--                <span>{{authData.messages.phone_code_get_message}}</span>-->
            <!--            </div>-->
            <div v-for="(input, i) in authData.regInputs">
                <input
                       v-if="input.type === 'hidden'"
                       :type="input.type"
                       :name="input.name"
                       :value="input.value"
                       :key="i + input.name"
                >
                <def-email
                    :key="i + input.name"
                    v-else-if="input.name === 'USER_EMAIL'"
                    :required="input.type !== 'hidden'"
                    :name="input.name"
                    :type="input.type"
                    :value="input.value"
                    :label="authData.placeholder.email"

                />
                <!--                <input type="hidden" v-else-if="input.type == 'hidden'" :name="input.name" :value="input.value">-->
                <def-input
                    v-else-if="input.name === 'USER_PASSWORD'||
                        input.name === 'USER_CONFIRM_PASSWORD' ||
                        input.name==='AUTH_FORM'
                        || input.name==='TYPE'"
                    :required="input.type !== 'hidden'"
                    :name="input.name"
                    :type="input.type"
                    :value="input.value"
                    :error="input.error"
                    :key="i"
                    :label="input.placeholder"

                />
            </div>
            <button class="def-button">{{ messages && messages.register_m }}</button>
        </div>
    </form>
</template>

<script>
import { mapState } from 'vuex';
import DefPhone from "../../def/DefPhone/DefPhone";

export default {
    name: 'registration-email',
    selector: '.registration-email',
    components: {
        DefPhone,
    },
    computed: {
        ...mapState({
            authData: ({ personal }) => personal.data,
            messages: ({ personal }) => personal.data.messages,
        })
    },
    methods: {
        async registerByEmail(e) {
            this.$store.dispatch('personal/registerByEmail', { e, component: this })
        },
        /**
         * получения кода рекаптчи для отправки на сервер
         */
        async recaptcha() {
            // this.$store.dispatch('personal/recaptcha', { component: this });
        },
    },

}
</script>

<style lang="scss" scoped>
.registration-email{
    width: 100%;
}

.enter-cabinet{
    &__tab{
        text-align: center;
    }
    .def-button{
        width: 100%;
    }
}
</style>